<div class="container">
  <app-text-card spacing="small">
    <p>
      {{
        'The table displays the resources where you are set as Primary or Secondary Owner, such as Teams, SharePoint sites, servers and Business Bookings calendars. Resources connected to RIS Projects are not shown in the table. Use the M365 Search to find and access all your other resources where you are owner or member.'
          | translate
      }}
    </p>
    <div style="margin-top: 12px">
      <button
        mat-flat-button
        color="primary"
        (click)="openInNewTab('https://m365.cloud.microsoft/search')"
      >
        {{ 'Open M365 Search' | translate }}
      </button>
    </div>
  </app-text-card>

  <form [formGroup]="filterMenu" class="filterOption">
    <mat-form-field class="filterMenu">
      <mat-label>{{ 'Search resources' | translate }}</mat-label>
      <input
        matInput
        id="input"
        type="text"
        formControlName="search"
        (keydown.enter)="filterSearch()"
        #input
      />
      <button
        matSuffix
        mat-icon-button
        aria-label="Search"
        (click)="filterSearch()"
      >
        <img
          src="../../assets/icons/Search--Streamline-Ultimate.svg"
          alt="Search"
        />
      </button>
    </mat-form-field>
    <mat-form-field class="filterMenu">
      <mat-label>{{ 'Type' | translate }}</mat-label>
      <mat-select
        id="type"
        formControlName="resourceType"
        (selectionChange)="filterType($event)"
        canSelectNullableOptions
        #typeSelect
      >
        <!--          <mat-option value="ris">RIS</mat-option>-->
        <mat-option>{{ 'none' | translate }}</mat-option>
        <mat-option value="team">Teams</mat-option>
        <mat-option value="sharepoint">SharePoint</mat-option>
        <mat-option value="server">Server</mat-option>
        <mat-option value="bookings">{{
          'Business Bookings Calendar' | translate
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="filterMenu">
      <mat-label>{{ 'Status' | translate }}</mat-label>
      <mat-select
        id="status"
        formControlName="resourceStatus"
        (selectionChange)="filterStatus($event)"
        #statusSelect
      >
        <mat-option>{{ 'none' | translate }}</mat-option>
        <mat-option value="active">{{ 'active' | translate }}</mat-option>
        <mat-option value="lifeCycle">{{ 'lifecycle' | translate }}</mat-option>
        <mat-option value="warning">{{ 'warning' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button
      mat-flat-button
      color="primary"
      class="filterMenu"
      (click)="clearFilter()"
    >
      {{ 'Clear' | translate }}
    </button>
  </form>

  <div
    *ngIf="
      dataIsLoaded &&
      (tableDataSource.data.length === 0 ||
        tableDataSource.filteredData.length === 0)
    "
    class="emptyBernieContainer"
  >
    <img class="emptyBernieImg" src="../../assets/images/BernieEmptyBox.png" />
    <p class="emptyBernieText" *ngIf="tableDataSource.data.length === 0">
      {{ 'No resources found.' | translate }}
    </p>
  </div>
  <div class="table">
    <div
      class="mat-elevation-z8"
      *ngIf="tableDataSource.filteredData.length > 0"
    >
      <table
        mat-table
        [dataSource]="tableDataSource"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="resourceType">
          <th mat-header-cell *matHeaderCellDef>{{ 'Type' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span class="icons-container">
              <img
                *ngIf="element.resourceType === ResourceTypes.TEAM"
                class="typeIcon"
                src="../../assets/images/MSTeamsIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.SHAREPOINT"
                class="typeIcon"
                src="../../assets/images/SharePointIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.SERVER"
                class="typeIcon"
                src="../../assets/images/ServerIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.BOOKINGS"
                class="typeIcon"
                src="../../assets/images/BookingsIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.SHAREPOINT"
                (click)="openInNewTab(element.url)"
                class="linkIcon"
                [matTooltip]="'Open SharePoint Site' | translate"
                src="../../assets/icons/Share-External-Link-1--Streamline-Ultimate.svg"
              />
              <!-- The booking page only exists when the business was published -->
              <img
                *ngIf="
                  element.resourceType === ResourceTypes.BOOKINGS && element.url
                "
                (click)="openInNewTab(element.url)"
                class="linkIcon"
                [matTooltip]="'Open booking page' | translate"
                src="../../assets/icons/Share-External-Link-1--Streamline-Ultimate.svg"
              />
              <!--                    <img *ngIf="element.resourceType === ResourceTypes.RIS" class="bfhIcon"-->
              <!--                         src="../../assets/images/BFHIcon.png">-->
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'Name' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span class="icons-container">
              <img
                *ngIf="
                  element.resourceStatus === ResourceStatus.WARNING ||
                  element.resourceStatus === ResourceStatus.LIFECYCLE
                "
                class="warningIcon"
                src="../../assets/icons/Alert-Hexagon--Streamline-Ultimate.svg"
                alt="Info"
                [matTooltip]="'Resource has no Secondary Owner' | translate"
              />
              <span [matTooltip]="element.displayName">{{
                element.displayName
              }}</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="primaryOwner">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Primary Owner' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.primaryOwner }}</td>
        </ng-container>

        <ng-container matColumnDef="secondaryOwner">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Secondary Owner' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.secondaryOwner }}
          </td>
        </ng-container>

        <ng-container matColumnDef="resourceStatus">
          <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.resourceStatus | translate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endOfLife">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Lifecycle end' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.endOfLife | date: 'dd.MM.yyyy' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span class="icons-container">
              <i
                ><img
                  *ngIf="
                    element.primaryOwner === this.userPrincipalName &&
                    element.resourceType !== ResourceTypes.SERVER
                  "
                  (click)="openEditResourceForm(element)"
                  class="actionIcon"
                  src="../../assets/icons/Pencil-1--Streamline-Ultimate.svg"
                  alt="Info"
                  [matTooltip]="'Edit properties' | translate"
              /></i>
              <i
                ><img
                  *ngIf="element.resourceStatus === ResourceStatus.LIFECYCLE"
                  (click)="openLifecycleForm(element)"
                  class="actionIcon"
                  src="../../assets/icons/Synchronize-Arrows-Three--Streamline-Ultimate.svg"
                  alt="Info"
                  [matTooltip]="'Renew lifecycle' | translate"
              /></i>
              <i
                ><img
                  class="actionIcon"
                  (click)="openDeleteResourceForm(element)"
                  src="../../assets/icons/Bin-1--Streamline-Ultimate.svg"
                  alt="Info"
                  [matTooltip]="'Delete resource' | translate"
              /></i>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr
          mat-row
          (click)="clickedRow(row)"
          [class.clickedRow]="selectedRow === row"
          *matRowDef="let row; columns: tableColumns"
        ></tr>
      </table>
      <mat-paginator
        *ngIf="tableDataSource.filteredData.length > 0"
        [pageSize]="10"
        [pageSizeOptions]="[10, 30, 50]"
        showFirstLastButtons
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
